const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://drrryrbzzj7z7.cloudfront.net";

/** Backend `figma_plugin_auth.SESSION_TTL_SEC` */
export const FIGMA_PLUGIN_AUTH_TTL_SEC = 600;
export const FIGMA_PLUGIN_AUTH_TTL_MS = FIGMA_PLUGIN_AUTH_TTL_SEC * 1000;

export interface FigmaPluginAuthSessionResponse {
  session_id: string;
  login_url: string;
  expires_at: number;
}

export interface FigmaPluginAuthStatusResponse {
  status: string;
  custom_token: string | null;
  session_id: string;
}

export async function createFigmaPluginAuthSession(): Promise<FigmaPluginAuthSessionResponse> {
  const res = await fetch(`${API_BASE_URL}/api/figma/plugin-auth/sessions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    throw new Error(await res.text());
  }
  return (await res.json()) as FigmaPluginAuthSessionResponse;
}

export async function completeFigmaPluginAuthSession(
  sessionId: string,
  idToken: string,
): Promise<Response> {
  return fetch(
    `${API_BASE_URL}/api/figma/plugin-auth/sessions/${encodeURIComponent(sessionId)}/complete`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    },
  );
}

export async function fetchFigmaPluginAuthStatus(
  sessionId: string,
): Promise<FigmaPluginAuthStatusResponse> {
  const res = await fetch(
    `${API_BASE_URL}/api/figma/plugin-auth/sessions/${encodeURIComponent(sessionId)}/status`,
  );
  if (!res.ok) {
    throw new Error(await res.text());
  }
  return (await res.json()) as FigmaPluginAuthStatusResponse;
}
